import createCache from '@emotion/cache'

const injectCSS = document.location.pathname.includes('/reports/view/')
export const emotionCache = createCache({
  key: 'studio',
  speedy: !injectCSS,
})
